const isArray = Array.isArray
const isNumber = (t: unknown) => typeof t === 'number'
const isString = (t: unknown) => typeof t === 'string'
const isObject = (t: unknown) => typeof t === 'object' && t !== null
const isElement = (t: unknown) => t instanceof HTMLElement
const isFunction = (t: unknown) => typeof t === 'function'

/** 获取函数名 */
const getName = (args: IArguments) => args.callee.name
/** 获取警告信息 */
const { warn } = console
/** Object.keys */
const { keys } = Object

/** 获取唯一key */
const getKey = (pre = '') => `${pre}${Math.random().toString(32).slice(4)}`

/** 只读 */
const readonlySet: any = () => warn('livecloud不可被重写')

/** 只读属性配置 */
const defineProperty = (object: Object, key: string, value: any) => {
  Object.defineProperty(object, key, {
    get:          () => value,
    set:          readonlySet,
    configurable: false
  })
}

/** 驼峰转换 */
const lowerCase = (attribute: string) => attribute.replace(/[A-Z]/g, s => `-${s.toLocaleLowerCase()}`)

const { head } = document

/** 类型判断 */
const TypeCheck = { isArray, isNumber, isString, isObject, isElement, isFunction }

/**
 * 插入style标签
 * @param str  插入的内容
 */
function appendStyle(str: string) {
  const style = document.createElement('style')
  style.type = 'text/css'
  style.textContent = str
  head.appendChild(style)
  return () => head.removeChild(style)
}

export {
  keys,
  warn,
  getKey,
  isArray,
  getName,
  isNumber,
  isObject,
  isString,
  lowerCase,
  TypeCheck,
  isElement,
  isFunction,
  appendStyle,
  readonlySet,
  defineProperty
}